import { styled } from "@mui/material"
import { AlertLevel, isAlertLevel } from "@phc/common"
import type React from "react"
import {
  Pill,
  pillVariantColors,
  type PillColors,
  type PillProps,
} from "./Pill"

const PillContainer = styled("div")({
  ".MuiBox-root": {
    padding: "0 4px",
    height: "fit-content",
    justifyContent: "center",
  },
})

export const alertColors: Record<
  AlertLevel,
  PillColors & { sidebarBackground: string }
> = {
  [AlertLevel.ADVISORY]: {
    ...pillVariantColors.green,
    sidebarBackground: `linear-gradient(180deg, ${pillVariantColors.green.background} 49.73%, ${pillVariantColors.green.text} 100%)`,
  },
  [AlertLevel.WATCH]: {
    ...pillVariantColors.yellow,
    sidebarBackground: `linear-gradient(180deg, ${pillVariantColors.yellow.background} 49.73%, ${pillVariantColors.yellow.text} 100%)`,
  },
  [AlertLevel.WARNING]: {
    ...pillVariantColors.red,
    sidebarBackground: `linear-gradient(180deg, ${pillVariantColors.red.background} 49.73%, ${pillVariantColors.red.text} 100%)`,
  },
}

export const getAlertColor = (alert_level: AlertLevel | undefined) => {
  if (isAlertLevel(alert_level)) {
    return alertColors[alert_level]
  }
}

export const getAlertVariant = (
  alert_level: AlertLevel | undefined
): PillProps["variant"] => {
  if (isAlertLevel(alert_level)) {
    switch (alert_level) {
      case AlertLevel.ADVISORY:
        return "green"
      case AlertLevel.WATCH:
        return "orange"
      case AlertLevel.WARNING:
        return "red"
    }
  }
}

export const AlertPill: React.FC<{
  alert_level: AlertLevel | undefined
  className?: string
}> = ({ alert_level, className }) => {
  if (!alert_level) return null
  return (
    <PillContainer className={className}>
      <Pill value={alert_level} variant={getAlertVariant(alert_level)} />
    </PillContainer>
  )
}
